
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productHandle]",
      function () {
        return require("private-next-pages/products/[productHandle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[productHandle]"])
      });
    }
  